<template>
    <div>
        <div>
            <el-button
                type="primary"
                size="small"
                icon="el-icon-back"
                @click="onBack()"
                >返回</el-button
            >
        </div>
        <br />
        <br />
        <el-form :v-model="list">
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="头像:"
                    style="width:30%;display: inline-block"
                >
                    <el-popover placement="right" trigger="hover">
                        <img
                            :src="list.userpic"
                            style="width:400px;border-radius:3px;"
                        />
                        <img
                            slot="reference"
                            :src="list.userpic"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;"
                        />
                    </el-popover>
                </el-form-item>
                <el-form-item
                    label="昵称:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input type="text" readonly :value="list.usernick" />
                </el-form-item>
            </el-form-item>
            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="注册时间:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input
                        :value="
                            list.userregisttime | formatDateStr('yyyy-MM-dd')
                        "
                        type="text"
                        readonly
                    />
                </el-form-item>
                <el-form-item
                    label="注册方式:"
                    style="width:30%;display: inline-block"
                >
                    <input
                        v-if="list.userregistype == 0"
                        value="邮箱注册"
                        readonly
                    />
                    <input
                        v-if="list.userregistype == 1"
                        value="Facebook"
                        readonly
                    />
                    <input
                        v-if="list.userregistype == 2"
                        value="Linkedin"
                        readonly
                    />
                </el-form-item>
            </el-form-item>
            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="邮箱地址:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input :value="list.useremail" readonly type="text" />
                </el-form-item>
                <el-form-item
                    label="上级:"
                    style="width:30%;display: inline-block"
                >
                    <input
                        v-if="this.supername != null"
                        :value="this.supername"
                        readonly
                        type="text"
                    />
                </el-form-item>
            </el-form-item>
            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="额度:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input :value="list.line" type="text" readonly />
                    <el-button
                        size="mini"
                        type="primary"
                        @click="editUserLine(list.userid)"
                        >操作</el-button
                    >
                </el-form-item>
                <el-form-item
                    label="积分:"
                    style="width:30%;display: inline-block"
                >
                    <input :value="list.userintegral" readonly type="text" />
                    <el-button
                        size="mini"
                        type="primary"
                        @click="integralDetail(list.userid)"
                        >查看明细</el-button
                    >
                </el-form-item>
            </el-form-item>
            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="用户等级:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input
                        :value="list.usergrade + '级'"
                        type="text"
                        readonly
                    />
                    <el-button
                        size="mini"
                        type="primary"
                        @click="editUserGrade(list.userid)"
                        >修改</el-button
                    >
                </el-form-item>
                <el-form-item
                    label="ID:"
                    style="width:30%;display: inline-block"
                >
                    <input :value="list.userid" readonly type="text" />
                </el-form-item>
            </el-form-item>
            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="登录时间:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input v-if="list.userregistertime == null" value="-" />
                    <input
                        v-if="list.userregistertime != null"
                        :value="
                            list.userregistertime
                                | formatDateStr('yyyy-MM-dd hh:mm:ss')
                        "
                        type="text"
                        readonly
                    />
                </el-form-item>
                <el-form-item
                    label="登录IP:"
                    style="width:30%;display: inline-block"
                >
                    <input
                        v-if="list.userip == null"
                        value="暂无IP"
                        readonly
                        type="text"
                    />
                    <input
                        v-if="list.userip != null"
                        :value="list.userip"
                        readonly
                        type="text"
                    />
                </el-form-item>
            </el-form-item>
            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="company:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input
                        v-if="list.usercpany == null"
                        value="-"
                        type="text"
                        readonly
                    />
                    <input
                        v-if="list.usercpany != null"
                        :value="list.usercpany"
                        type="text"
                        readonly
                    />
                </el-form-item>
                <el-form-item
                    label="tel:"
                    style="width:30%;display: inline-block"
                >
                    <input
                        v-if="list.usermobile == null"
                        value="-"
                        readonly
                        type="text"
                    />
                    <input
                        v-if="list.usermobile != null"
                        :value="list.usermobile"
                        readonly
                        type="text"
                    />
                </el-form-item>
            </el-form-item>
            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="website:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input
                        v-if="list.userwebsite == null"
                        value="-"
                        type="text"
                        readonly
                    />
                    <input
                        v-if="list.userwebsite != null"
                        :value="list.userwebsite"
                        type="text"
                        readonly
                    />
                </el-form-item>
                <el-form-item
                    label="country:"
                    style="width:30%;display: inline-block"
                >
                    <input
                        v-if="list.countryenglishname == null"
                        value="-"
                        readonly
                        type="text"
                    />
                    <input
                        v-if="list.countryenglishname != null"
                        :value="list.countryenglishname"
                        type="text"
                        readonly
                    />
                </el-form-item>
            </el-form-item>

            <br />
            <!-- 新增两个字段 -->
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="linkedin:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input
                        v-if="list.userlinkedin == null"
                        value="-"
                        type="text"
                        readonly
                    />
                    <input
                        v-if="list.userlinkedin != null"
                        :value="list.userwebsite"
                        type="text"
                        readonly
                    />
                </el-form-item>
                <el-form-item
                    label="认证信息:"
                    style="width:30%;display: inline-block"
                >
                    <input
                        v-if="list.info == null"
                        value="-"
                        readonly
                        type="text"
                    />
                </el-form-item>
            </el-form-item>

            <br />
            <el-form-item
                style="border-bottom:1px solid #ebeef5;"
                label-width="0px"
            >
                <el-form-item
                    label="专属销售:"
                    style="width:30%;display: inline-block;margin-left:0px;"
                >
                    <input :value="list.compellation" type="text" readonly />
                    <el-button size="mini" type="primary" @click="editSell()"
                        >修改</el-button
                    >
                </el-form-item>
            </el-form-item>
            <!-- 添加地址 -->
            <el-form-item label="地址:">
                <br />
                <el-card
                    class="box-card"
                    v-for="(item, index) in address"
                    :key="index"
                >
                    <div slot="header" class="clearfix">
                        <span>address{{ index + 1 }}:</span>
                    </div>
                    <el-form-item
                        label="收货人:"
                        style="width:30%;display: inline-block;margin-left:0px;"
                    >
                        <input
                            type="text"
                            readonly
                            :value="item.useraddressname"
                        />
                    </el-form-item>

                    <el-form-item
                        label="联系电话:"
                        style="width:30%;display: inline-block;margin-left:0px;"
                    >
                        <input
                            type="text"
                            readonly
                            :value="item.useraddressphone"
                        />
                    </el-form-item>
                    <el-form-item label="收货地址:">
                        <!-- <input type="text" readonly :value="item.useraddress" /> -->
                        <div v-html="item.useraddress" readonly />
                    </el-form-item>
                </el-card>
            </el-form-item>
            <!-- 企业信息 -->
            <el-form-item label="企业信息:">
                <br />
                <el-card class="box-card">
                    <el-form-item
                        label="公司名称:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                             <input
                                 type="text"
                                 v-model="list.name"
                             />
<!--                            {{ list.name || "-" }}-->

                        <!-- <input type="text" readonly value="韩东科技" /> -->
                    </el-form-item>
                    <el-form-item
                        label="行业:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.industry"
                        />
                        <!-- <input type="text" readonly value="互联网/移动互联网" /> -->
                    </el-form-item>
                    <br />
                    <el-form-item
                        label="地址:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.address"
                        />
                    </el-form-item>
                    <el-form-item
                        label="电话:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.tel"
                        />
                    </el-form-item>
                    <br />
                    <el-form-item
                        label="网站:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.website"
                        />
                    </el-form-item>
                    <el-form-item
                        label="国家:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.country"
                        />
                    </el-form-item>
                    <br />
                    <el-form-item
                        label="城市:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.city"
                        />
                    </el-form-item>
                    <el-form-item
                        label="邮编:"
                        style="width:50%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.zipcode"
                        />
                    </el-form-item>
                    <br />
                    <el-form-item
                        label="备注信息:"
                        style="width:100%;display: inline-block;margin-left:0px;"
                    >

                        <input
                            type="text"
                            v-model="list.remark"
                        />
                        <!-- <input
                            type="text"
                            style=""
                            readonly
                            value="朝阳区建国路88号SOHO现代城C座底商S1502"
                        /> -->
                    </el-form-item>
                    <el-button
                        size="mini"
                        type="primary"
                        @click="updEnterpriseBtn()"
                    >修改</el-button
                    >
                </el-card>
            </el-form-item>

        </el-form>
        <!-- </el-dialog> -->
        <el-dialog
            title="修改等级"
            :visible.sync="gradeVisible"
            :before-close="editGrade"
            width="15%"
            v-dialogDrag
        >
            <el-form :model="list" ref="dataForm">
                <el-form-item class="query-form-item" prop="usergrade">
                    <el-select
                        v-model="list.usergradesort"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in grades"
                            :key="index"
                            :label="item.usergradesort"
                            :value="item.usergradesort"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editGrade">取消</el-button>
                <el-button
                    type="primary"
                    @click.native="saveGrade()"
                    :loading="formLoading"
                    >确定</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            title="修改额度"
            :visible.sync="lineVisible"
            :before-close="editline"
            width="13%"
            v-dialogDrag
        >
            <el-form :model="list" ref="dataForm">
                <el-form-item label prop="linetype" width="100%">
                    <el-select v-model="list.linetype" clearable>
                        <el-option label="增加" value="0"></el-option>
                        <el-option label="减少" value="1"></el-option>
                    </el-select>
                    <el-input
                        v-model="list.linesize"
                        placeholder="请输入额度"
                        clearable
                        min="100px"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editline">取消</el-button>
                <el-button
                    type="primary"
                    @click="saveLine()"
                    :loading="formLoading"
                    >确定</el-button
                >
            </div>
        </el-dialog>

        <el-dialog
            title="修改客服（销售）"
            :visible.sync="sellVisible"
            :before-close="cancelSell"
            width="15%"
            v-dialogDrag
        >
            <el-form ref="dataForm">
                <el-form-item class="query-form-item">
                    <el-select
                        placeholder="请选择"
                        v-model="sale"
                        value-key="id"
                        @change="modifySale"
                    >
                        <el-option
                            v-for="item in sales"
                            :key="item.id"
                            :label="item.compellation"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelSell">取消</el-button>
                <el-button
                    type="primary"
                    @click="saveSell()"
                    :loading="formLoading"
                    >确定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getListByUserId,
    getListAll,
    getAllGrade,
    editGrade,
    getUserAddress,
    getSuperNameBySuperId,
    getSale, // 获取所有销售
    editSale, // 修改销售
    updEnterprise //修改企业信息，有修改，没有增加
} from "../../api/mbUser/mbUser";
import { editLine } from "../../api/mbLine/editLine";

const formJson = {
    usernick: "",
    emailaddress: "",
    userpassword: "",
    userid: ""
};
export default {
    data() {
        return {
            options: [],
            selectedOptions: [],
            labelPosition: "right",
            isrelogin: "",
            cancelToggle: false,
            createTime: [],

            query: {
                startTime: "",
                endTime: "",
                content: "",
                currentPage: 1,
                pageSize: 10,
                userid: "",
                usersuperiorid: ""
            },
            lines: [],
            address: [],
            usersuperiorid: "",
            grades: [],
            sales: [], // 所有销售人员
            sale: {}, // 被选中的销售人员
            divLoading: "",
            list: "",
            serList: [],
            mbUserSer: [],
            supername: "",
            selectedCity: [],
            firstDeparts: [],
            // hospitalnamelist: [], //添加主管医院的集合
            totalNumber: 0,
            loading: true,
            index: null,
            formName: null,
            gradeVisible: false,
            sellVisible: false,
            lineVisible: false,
            formLoading: false,
            formVisible: false,
            detailVisible: false,
            formData: formJson,
            multipleSelection: [] //多选集合,
        };
    },
    methods: {
        onBack() {
            //返回上一页
            this.$router.go(-1);
        },
        //修改额度
        saveLine() {
            editLine(this.list).then(response => {
                this.formLoading = false;
                if (response.code) {
                    this.$message.error(response.message);
                    return false;
                }
                if (response.data == 2) {
                    this.$message.error("超出该用户的额度！！！");
                } else {
                    this.$message.success("操作成功");
                }

                // 刷新表单
                this.lineVisible = false;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.list.linetype = "";
                this.list.linesize = "";
                // 加载表格数据
                this.getListByUserId();
            });
        },
        dateChange(val) {
            if (val == null) {
                this.query.startTime = "";
                this.query.endTime = "";
            } else {
                this.query.startTime = val[0];
                this.query.endTime = val[1];
            }
            this.getListByUserId();
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (val == "") {
                this.cancelToggle = false;
                return;
            }
            this.cancelToggle = true;
        },
        onRest() {
            this.query = {
                startTime: "",
                endTime: "",
                firstid: "",
                currentPage: 1,
                pageSize: 10
            };
            this.createTime = [];
            this.getListByUserId();
        },
        //跳转积分明细页面
        integralDetail(userid) {
            this.$router.push({
                path: "/mbUser/integralDetail",
                query: {
                    userid: userid
                }
            });
        },
        //保存等级
        saveGrade() {
            editGrade(this.list).then(response => {
                this.formLoading = false;
                if (response.code) {
                    this.$message.error(response.message);
                    return false;
                }

                this.$message.success("操作成功");
                // 刷新表单
                this.gradeVisible = false;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                // 加载表格数据
                this.getListByUserId();
            });
        },
        getListByUserId() {
            this.loading = true;
            getListByUserId({userid:this.userid})
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.list = response.data;
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {
                    this.loading = false;
                    this.list = "";
                });
        },
        getListAll() {
            getListAll(this.query)
                .then(res => {
                    this.serList = res.data || [];
                })
                .catch(() => {});
        },
        getAllGrade() {
            getAllGrade(this.query)
                .then(res => {
                    this.grades = res.data || [];
                })
                .catch(() => {});
        },
        //隐藏修改等级
        editGrade() {
            this.gradeVisible = !this.gradeVisible;
            this.list.usergradesort = "";
            return true;
        },
        //隐藏修改专属销售
        cancelSell() {
            this.sellVisible = !this.sellVisible;
            this.list.usergradesort = "";
            return true;
        },
        //隐藏修改额度
        editline() {
            this.lineVisible = !this.lineVisible;
            this.list.linetype = "";
            this.list.linesize = "";
            return true;
        },
        //显示修改等级
        editUserGrade(userid) {
            console.log(userid);
            this.gradeVisible = true;
        },
        //显示修改专属销售
        editSell(userid) {
            console.log(userid);
            this.sellVisible = true;
        },
        //显示修改额度
        editUserLine() {
            this.lineVisible = true;
        },
        //查询上级
        getSuperNameBySuperId() {
            getSuperNameBySuperId(this.query)
                .then(res => {
                    this.supername = res.data.supername;
                })
                .catch(() => {});
        },
        //地址
        getUserAddress() {
            getUserAddress(this.query)
                .then(res => {
                    this.address = res.data || [];
                })
                .catch(() => {});
        },
        modifySale(e) {
            console.log(e);
            console.log(this.sale);
        },
        //修改专属销售确定按钮
        saveSell() {
            editSale({ id: this.sale.id, userId: this.userid })
                .then(res => {
                    if (res.code) {
                        this.$message.error(res.message);
                        return false;
                    }
                    this.list.compellation = this.sale.compellation;
                    this.$message.success("操作成功");
                    this.sellVisible = false;
                })
                .catch(() => {
                    this.sellVisible = false;
                });
        },updEnterpriseBtn(){
            var data=this.list;
            var params={};
            // 用户id
             params.userId=data.userid;
            //公司id
            params.id=data.enterpriseid;
            //公司名称
            params.name=data.name;
// //        //行业
            params.industry=data.industry;
// //        //地址
            params.address=data.address;
// //        //电话
            params.tel=data.tel;
// //        //网站
            params.website=data.website;
// //        //国家
            params.country=data.country;
// //        //城市
            params.city=data.city;
// //        //邮编
            params.zipcode=data.zipcode;
// //        //备注信息
            params.remark=data.remark;
            console.log("list=", data);
            console.log("params=", params);
            updEnterprise(params).then(res=>{
                console.log("res=",res);
                if(res.code==0){
                    this.$message.success("操作成功");
                }else{
                    this.$message.error("操作失败");
                }
                // if (res.data == 0) {
                //     this.$message.error("超出该用户的额度！！！");
                // } else {
                   // this.$message.success("操作成功");
                // }
             });
        },
        // 获取所有销售人员
        getSale() {
            getSale({})
                .then(res => {
                    this.sales = res.data || [];
                })
                .catch(() => {
                    this.sales = [];
                });
        }
    },

    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.pageSize = parseInt(this.query.pageSize);
        // 加载表格数据
        this.userid = this.$route.query.userid;
        this.usersuperiorid = this.$route.query.usersuperiorid;
        this.getListByUserId();
        this.getUserAddress();
        this.getListAll();
        this.getAllGrade();
        this.getSuperNameBySuperId();
        this.getSale(); // 获取所有销售人员
    }
};
</script>

<style type="text/scss" lang="scss"></style>
